module.exports = __webpack_public_path__ + "img/img_logo_sichuan.7227a3f2.png";